<template lang="pug">
  .panel-page-white
    .panel-white.body-2(:class="panelClass")
      slot
</template>

<script>
export default {
  name: 'PrintablePanel',
  computed: {
    panelClass() {
      return {
        'mx-auto': !this.printable,
        print: this.printable,
      }
    },
  },
}
</script>


<style lang="scss" scoped>
.panel-white {
  width: 1007px;
}

.panel-white.print {
  width: auto;
}

@media print {
  * {
    display: block !important;
    float: none !important;
    flex: none !important;
    overflow-y: visible !important;
    overflow-x: visible !important;
    overflow: visible !important;
  }
}
</style>
